import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
import SandwichBuilder from '../components/menu/SandwichBuilder';
import SpecialtySandwiches from '../components/menu/SpecialtySandwiches';
import FeaturedSandwich from '../components/menu/FeaturedSandwich';
import './MenuPage.css';
import './SandwichMenuPage.css';

const SandwichMenuPage = () => {
  const [activeTab, setActiveTab] = useState('basic-sandwiches');
  
  // Custom nav items for sandwich menu only
  const sandwichNavItems = [
    { id: 'basic-sandwiches', label: 'Build Your Own' },
    { id: 'specialty-sandwiches', label: 'Specialty Sandwiches' }
  ];
  
  // Handle tab change
  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    // No scrolling needed now - just switch tabs in place
  };

  return (
    <div className="menu-page sandwich-menu-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <h1 className="force-revue">Sandwich Menu</h1>
          <p>Quality ingredients, expertly crafted, served fresh daily</p>
          
          <div className="call-notice">
            <h3><FontAwesomeIcon icon={faPhoneAlt} /> You Must Call To Order</h3>
            <p>This is not an online order form.</p>
          </div>
        </div>
      </section>
      
      {/* Featured Sandwich will now only appear in the specialty sandwiches section */}
      
      {/* Tab Navigation */}
      <div className="tab-navigation">
        <div className="container">
          {sandwichNavItems.map(item => (
            <button
              key={item.id}
              className={`tab-button ${activeTab === item.id ? 'active' : ''}`}
              onClick={() => handleTabChange(item.id)}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>
      
      {/* Sandwich Content Area */}
      <div className="sandwich-content-area">
        <div className="container">
          {activeTab === 'basic-sandwiches' && (
            <section id="basic-sandwiches" className="menu-section">
              <h2 className="section-title force-revue">Build Your Own Sandwich</h2>
              <p className="section-description">
                Create your perfect sandwich with our premium deli meats and toppings
              </p>
              
              <SandwichBuilder />
            </section>
          )}
          
          {activeTab === 'specialty-sandwiches' && (
            <section id="specialty-sandwiches" className="menu-section">
              {/* Featured Sandwich appears only in the specialty sandwiches tab */}
              <FeaturedSandwich />
              
              <h2 className="section-title force-revue">Specialty Sandwiches</h2>
              <p className="section-description">
                Our legendary sandwich creations, expertly crafted with premium ingredients
              </p>
              
              <SpecialtySandwiches />
            </section>
          )}
        </div>
      </div>
      
      <div className="food-safety-disclaimer">
        <div className="container">
          <p>*CONSUMING RAW OR UNDERCOOKED MEATS, POULTRY, SEAFOOD, SHELLFISH, OR EGGS MAY INCREASE YOUR RISK OF FOODBORNE ILLNESS, ESPECIALLY IF YOU HAVE CERTAIN MEDICAL CONDITIONS.</p>
        </div>
      </div>
    </div>
  );
};

export default SandwichMenuPage;
